import * as Sentry from '@sentry/browser';
import Game from './Game';

let sentryEnabled = false;

export function sentryInit() {
    Sentry.init({
        // @ts-ignore
        release: __VERSION__,
        dsn: 'https://0971a53f2f5e4325a8eb625f1824419a@sentry.io/1459241',
        environment: process.env.NODE_ENV,
        // Append redux state.
        beforeSend(event, hint?) {
            try {
                event.extra = { 'redux-state': Game.state.getState() };
            } catch (err) {
                event.extra = {
                    'redux-state': {
                        message: 'State not available.',
                        error: err,
                    },
                };
            }
            return event;
        },
    });

    sentryEnabled = true;
}

export function setSentryUserID(ID: string) {
    if (!sentryEnabled || !ID) return;

    Sentry.configureScope(scope => {
        scope.setUser({ id: ID });
    });
}

export function captureException(err: any) {
    console.log(err);
    if (!sentryEnabled) return;
    Sentry.captureException(err);
}
